/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction } from '@reduxjs/toolkit'
import { SchemaField } from 'features/data-explorer/types'
import { AttributeStats } from '../types'
import { TilejsonResult } from '@carto/api-client'

const extraActions = {
  updateTilesetDatasetAttributeStats: createAction<{
    datasetId: string
    stats: AttributeStats
  }>('@@kepler.gl/UPDATE_DATASET_ATTRIBUTE_STATS'),
  updateTilesetHexColumnStats: createAction<{
    datasetId: string
    stats: AttributeStats
  }>('@@kepler.gl/UPDATE_DATASET_HEX_COLUMN_STATS'),
  setIsLayerLoadingTiles: createAction<{ layerId: string; isLoadingTiles: boolean }>(
    '@@kepler.gl/IS_LAYER_LOADING_TILES'
  ),
  updateTilesetDatasetTilejson: createAction<{
    datasetId: string
    tilejson?: TilejsonResult | null
    schema?: SchemaField[] | null
  }>('@@kepler.gl/UPDATE_DATASET_TILEJSON'),
  updateTilesetDatasetResolution: createAction<{
    datasetId: string
    aggregationResLevel: number
  }>('@@kepler.gl/UPDATE_DATASET_TILES_ZOOM_LEVELS')
}

export const {
  updateTilesetDatasetAttributeStats,
  updateTilesetHexColumnStats,
  setIsLayerLoadingTiles,
  updateTilesetDatasetTilejson,
  updateTilesetDatasetResolution
} = extraActions
